import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import APProfilePhoto from "../../atoms/APProfilePhoto";
import APContactSectionClosedStyles from "./styles/APContactSectionClosed.style";
import { ReducerState } from '../../../redux/modules';
import { connect } from "react-redux";
import { AffiliateDetailsAttributes } from "../../../core/types/AffiliateDetails";

interface APContactSectionClosedProps
  extends WithStyles<typeof APContactSectionClosedStyles> {
  affiliateDetails: AffiliateDetailsAttributes | null 
}

class APContactSectionClosed extends Component<
  APContactSectionClosedProps,
  {}
> {
  render() {
    const { classes, affiliateDetails } = this.props;
    const sourceURL: string | undefined = affiliateDetails?.affiliate?.photoUrl;

    return (
      <div className={classes.contactContainer}>
        <div className={classes.managerDetails}>
          <APProfilePhoto className={classes.managerPhoto} sourceURL={sourceURL} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  affiliateDetails: store.user.affiliateDetails,
});

export default connect(mapStateToProps)(
  withStyles(APContactSectionClosedStyles)(APContactSectionClosed)
);
